import moment from 'moment'
export const formatDateMixin = {
  filters: {
    formatDate (val, showAbsolute) {
      if (!val) { return '-' }

      const date = val.toDate()

      moment.locale('pt-BR')

      const relativeDate = moment(date).fromNow()
      const absoluteDate = moment(date).format('DD/MM/YYYY')

      return showAbsolute ? absoluteDate : relativeDate
    }
  }
}

export const trimLengthMixin = {
  filters: {
    trimLength (val, max) {
      max = max || 300
      val = val.replace(/<[^>]*>?/gm, '').replace(/(&nbsp;)+/g, '')
      if (val.length < max) {
        return val
      }
      return `${val.substring(0, max)}...`
    }
  }
}
